<template>
    <el-dialog title="Vin" :visible.sync="thisvisible">
        <div class="form-container">
            <div v-loading="loading" class="form-container">
                <el-form
                    ref="vinForm"
                    :model="thisvin"
                    :rules="rules"
                    label-position="left"
                    label-width="150px"
                    style="max-width: 500px;"
                >
                    <el-form-item
                        label="Nom"
                        prop="nom"
                        :error="getErrorForField('nom', errors)"
                    >
                        <el-input v-model="thisvin.nom" />
                    </el-form-item>
                    <el-form-item
                        label="Max"
                        prop="max"
                        type="number"
                        :error="getErrorForField('max', errors)"
                    >
                        <el-input v-model="thisvin.max" />
                    </el-form-item>
                    <el-form-item
                        label="Description"
                        prop="description"
                        :error="getErrorForField('description', errors)"
                    >
                        <el-input
                            type="textarea"
                            v-model="thisvin.description"
                        />
                    </el-form-item>
                    <template v-if="thisvin.id">
                        <el-form-item
                            v-for="field in fieldsPhoto"
                            :key="field"
                            :label="labels[field]"
                            :prop="field"
                        >
                            <div v-if="thisvin[field] && !replace[field]">
                                <el-image
                                    class="userimage"
                                    :src="thisvin[field + '_url'].mini"
                                    fit="cover"
                                />
                                <div class="controls">
                                    <el-link
                                        type="primary"
                                        icon="el-icon-refresh"
                                        :underline="false"
                                        @click="
                                            replace[field] = !replace[field]
                                        "
                                    />
                                    <el-link
                                        type="danger"
                                        icon="el-icon-delete"
                                        :underline="false"
                                        @click="handleDeletePhoto(field)"
                                    />
                                </div>
                            </div>
                            <el-upload
                                v-else
                                drag
                                :action="'/api/vins/' + thisvin.id + '/files'"
                                :on-success="
                                    (res, file, fileList) =>
                                        handleSucess(res, file, fileList, field)
                                "
                                :headers="headers"
                                :on-error="handleError"
                                :file-list="fileList"
                                :name="field"
                            >
                                <i class="el-icon-upload" />
                                <div class="el-upload__tip">
                                    jpg
                                </div>
                                <div
                                    v-if="replace[field]"
                                    slot="tip"
                                    class="el-upload__tip cursopointer"
                                    @click="replace[field] = !replace[field]"
                                >
                                    Annuler
                                </div>
                            </el-upload>
                        </el-form-item>
                    </template>
                    <el-form-item>
                        <el-button type="info" @click="thisvisible = false">
                            Annuler
                        </el-button>
                        <el-button type="primary" @click="save">
                            Enregistrer
                        </el-button>
                        <el-button
                            v-if="thisvin.id"
                            type="danger"
                            @click="supprimer"
                        >
                            Supprimer
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Resource from "@/api/resource";
import { getToken } from "@/utils/auth";

const vinResource = new Resource("vins");

export default {
    name: "Vin",
    props: {
        isvisible: {
            type: Boolean,
            default: false
        },
        vin: {
            type: Object,
            default: () => {
                return {
                    nom: "",
                    max: 8,
                    description: "",
                    photo: ""
                };
            }
        },
        parent: {
            type: Object
        }
    },
    data() {
        return {
            thisvisible: false,
            loading: false,
            rules: {},
            errors: [],
            fileList: [],
            headers: {
                Authorization: "Bearer " + getToken()
            },
            // fieldsPhoto: ["photo", "photo_back"],
            fieldsPhoto: ["photo"],
            replace: {
                photo: false,
                photo_back: false
            },
            labels: {
                photo: "photo face",
                photo_back: "photo dos"
            },
            thisvin: {
                nom: "",
                max: 8,
                description: "",
                photo: ""
            }
        };
    },
    watch: {
        isvisible(val) {
            if (val) {
                this.thisvisible = val;
                this.errors = [];
                if (this.vin) {
                    Object.assign(this.thisvin, this.vin);
                }
            }
        },
        thisvisible(val) {
            if (!val) {
                this.parent.dialogVinVisible = val;
                this.errors = [];
            }
        }
    },
    computed: {},
    methods: {
        handleSucess(response, file, fileList, col) {
            //var col = 'photo';
            console.log(response);
            console.log(file);
            console.log(fileList);
            console.log("col es" + col);
            if (response.data) {
                this.thisvin[col] = response.data[col];
                this.thisvin[col + "_url"] = response.data[col + "_url"];
                this.vin[col] = response.data[col];
                this.vin[col + "_url"] = response.data[col + "_url"];
                this.replace[col] = false;
            } else if (response.error) {
                this.$message({
                    type: "error",
                    message: response.error,
                    duration: 1 * 5000
                });
            }
        },
        handleError(err) {
            this.$message({
                type: "error",
                message: err,
                duration: 1 * 5000
            });
        },
        handleDeletePhoto(col) {
            console.log("del" + col);
            this.$confirm("Voulez-vous supprimer cette photo ?", "Attention", {
                confirmButtonText: "OUI",
                cancelButtonText: "Annuler",
                type: "warning"
            })
                .then(() => {
                    this.vin[col] = null;
                    this.vin[col + "_url"] = null;
                    this.thisvin[col] = null;
                    this.thisvin[col + "_url"] = null;
                    this.save();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "Suppression annulée"
                    });
                });
        },
        save() {
            this.errors = [];
            this.loading = true;
            if (this.vin.id) {
                vinResource
                    .update(this.thisvin.id, this.thisvin)
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.parent.callbackVin(false, response.data);
                        this.$message({
                            message: "Vin mis à jour",
                            type: "success",
                            duration: 5 * 1000
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            } else {
                vinResource
                    .store(this.thisvin)
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.$message({
                            message: "Vin créée",
                            type: "success",
                            duration: 5 * 1000
                        });
                        console.log(response);
                        this.parent.callbackVin(true, false);
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            }
        },
        supprimer() {
            this.$confirm("Voulez-vous supprimer ce vin", "Attention", {
                confirmButtonText: "Supprimer",
                cancelButtonText: "Anuler",
                type: "warning"
            })
                .then(() => {
                    this.loading = true;
                    vinResource
                        .destroy(this.vin.id)
                        .then(response => {
                            console.log(response);
                            this.loading = false;
                            this.thisvisible = false;
                            this.$message({
                                type: "success",
                                message: "Suppression effectuée"
                            });
                            this.parent.callbackVin(true, false);
                        })
                        .catch(error => {
                            console.log(error);
                            this.loading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "Suppression Anulée"
                    });
                });
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        }
    }
};
</script>
